import { render, staticRenderFns } from "./DeveloperSetting.vue?vue&type=template&id=45d2770a&"
import script from "./DeveloperSetting.vue?vue&type=script&lang=js&"
export * from "./DeveloperSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports